module.exports = __webpack_public_path__ + "static/img/qiehuan.4f9d21a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/view6/qiehuan.png
// module id = u0Ik
// module chunks = 1